module.exports = __webpack_public_path__ + "img/hxkj-text-1.5f7c7b29.svg";